import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  locate(event) {
    if (this.submitting) return

    event.preventDefault()
    const button = event.submitter
    if (button) {
      button.setAttribute("aria-busy", "true")
      button.disabled = true
    }

    if (!navigator.geolocation) {
      this.submitWithUnavailableReason("unsupported", button)
      return
    }

    navigator.geolocation.getCurrentPosition(
      (position) => this.submitWithPosition(position, button),
      (error) => this.submitWithUnavailableReason(this.reasonFor(error.code), button),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 30000 }
    )
  }

  submitWithPosition(position, button) {
    this.field("latitude").value = position.coords.latitude
    this.field("longitude").value = position.coords.longitude
    this.field("accuracy").value = position.coords.accuracy
    this.field("unavailable_reason").value = ""
    this.submit(button)
  }

  submitWithUnavailableReason(reason, button) {
    this.field("latitude").value = ""
    this.field("longitude").value = ""
    this.field("accuracy").value = ""
    this.field("unavailable_reason").value = reason
    this.submit(button)
  }

  submit(button) {
    this.submitting = true
    if (button) button.disabled = false
    this.element.requestSubmit(button)
  }

  field(name) {
    return this.element.elements[`location[${name}]`]
  }

  reasonFor(code) {
    return { 1: "denied", 2: "unavailable", 3: "timeout" }[code] || "unavailable"
  }
}
